<script setup lang="ts">
// État de synchronisation de CET appareil : ce qui n'est pas sur le serveur
// ne sera pas retrouvé sur Inspexio, le stockage local ne suivant pas d'un
// domaine à l'autre.
import { useTranslation } from "i18next-vue";
import { useUnsyncedDrawings } from "@/composable/useUnsyncedDrawings";

const emit = defineEmits<{ (e: "navigate"): void }>();

const { t } = useTranslation();
const { unsyncedCount } = useUnsyncedDrawings();
</script>

<template>
  <div
    v-if="unsyncedCount === 0"
    class="sync-status sync-status--ok d-flex align-items-center gap-2"
  >
    <i class="bi-check-circle-fill" aria-hidden="true" />
    <span>{{ t("brandMigration.syncOk") }}</span>
  </div>
  <div v-else class="sync-status sync-status--pending d-flex gap-2">
    <i class="bi-exclamation-triangle-fill" aria-hidden="true" />
    <div class="d-flex flex-column gap-1">
      <span>{{
        t("brandMigration.syncPending", { count: unsyncedCount })
      }}</span>
      <router-link
        :to="{ name: 'synchronization-issues' }"
        class="fw-semibold"
        @click="emit('navigate')"
      >
        {{ t("brandMigration.syncLink") }}
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sync-status {
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;

  &--ok {
    background-color: var(--bs-success-bg-subtle);
    color: var(--bs-success-text-emphasis);
  }

  &--pending {
    background-color: var(--bs-warning-bg-subtle);
    color: var(--bs-warning-text-emphasis);
  }
}
</style>
